"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.capText = capText;
exports.stripHtml = stripHtml;

/**
 * This caps a given string to a given amount of characters and appends ... to it.
 * @param {*} string
 * @param {*} limit
 */
function capText(str, limit) {
  var result = str.replace(/\n|\r/gi, '');

  if (result.length > limit) {
    for (var i = limit; i > 0; i--) {
      if (result.charAt(i) === ' ' && (result.charAt(i - 1) !== ',' || result.charAt(i - 1) !== '.' || result.charAt(i - 1) !== ';')) {
        return result.substring(0, i) + '...';
      }
    }

    return result.substring(0, limit) + '...';
  } else {
    return result;
  }
}
/**
 * Removes html from a string.
 * @param {*} html
 * @param {*} options
 */


function stripHtml(html, options) {
  var result = html;
  var opts = options || {
    preserveLineBreaks: false
  };

  if (opts.preserveLineBreaks) {
    result = result.replace(/<br(.+?)?>/gim, '\r\n');
  }

  var div = document.createElement('div');
  div.innerHTML = result;
  return div.innerText;
}